import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { DateTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { CreateChargeDialogComponent } from './create-charge-dialog/create-charge-dialog.component';
import { EditChargeDialogComponent } from './edit-charge-dialog/edit-charge-dialog.component';

@Component({
    selector: 'kiene-charges',
    templateUrl: './charges.component.html',
    styleUrls: ['./charges.component.scss'],
})
export class ChargesComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private dialog: MatDialog,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Chargen';
        this.tableDescriptor.uniqueIdentifier = 'Chargen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'charge/';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.nameOfIdField = 'charge_id';
        this.tableDescriptor.showDetailsVoid = this.openEditChargeDialog.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('charge_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('charge', 'Charge'));
        this.tableDescriptor.columns.push(new TableColumn('artikel', 'Artikel'));
        this.tableDescriptor.columns.push(new TableColumn('mhd', 'MHD'));
        this.tableDescriptor.columns.push(new DateTableColumn('erstellt', 'Erstellt'));

        this.tableDescriptor.options.push(
            new TableOption(this.openEditChargeDialog.bind(this), 'Charge bearbeiten', 'edit', 1042),
        );

        this.tableDescriptor.initialSortColumn = 'erstellt';
        this.tableDescriptor.initialSortDirection = 'desc';

        this.tableDescriptor.permissionCreate = 1042;
        this.tableDescriptor.addVoid = this.openCreateDialog.bind(this);
    }

    openCreateDialog() {
        const dialogRef = this.dialog.open(CreateChargeDialogComponent);

        dialogRef.afterClosed().subscribe({
            next: charge => {
                if (charge) {
                    this.api.post(this.apiBaseUrl + 'charge/create.php', charge).subscribe({
                        next: () => {
                            this.api.reload();
                        },
                        error: err => {
                            this.messageService.errorMessage('Die Charge konnte nicht angelegt werden!', err);
                        },
                    });
                }
            },
        });
    }

    private openEditChargeDialog(charge: Charge): void {
        const input = new ChargeEditInput();
        input.charge = charge;

        this.dialog
            .open(EditChargeDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: value => {
                    if (value?.confirm) {
                        this.api.updateEntity(this.apiBaseUrl + 'charge/update.php', value.charge).subscribe({
                            next: () => {
                                this.api.reload();
                            },
                            error: err => {
                                this.messageService.errorMessage('Die Charge konnte nicht geändert werden!', err);
                            },
                        });
                    }
                },
            });
    }
}

export class Charge {
    benutzerid: number;
    charge: string;
    charge_id: number;
    artikel: string;
    artikel_id: number;
    mhd: string;
    apotheke: string;
    lager: string;
    wagen: string;
    summe: string;
    erstellt: Date;
    chargenmenge: number;
}

export interface ChargeApi {
    records: Charge[];
    count: number;
}

export class ChargeEditInput {
    charge: Charge;
}

export class ChargeEditResult {
    charge: Charge;
    confirm: boolean;
}
